module.exports = __webpack_public_path__ + "media/images/redesign-images/fraternity/product-images/product-model-3-9b2be39ee796bd5a1290da512e222e12.jpg";